import React from "react"
import { MyControlHelpers } from "@macashipo/mlib"

const MC_check_with_icon = React.lazy(() => import("./Types/check_with_icon"))
const MC_check_inbox = React.lazy(() => import("./Types/check_inbox"))
const MC_select_year_month = React.lazy(
  () => import("./Types/select_year_month")
)
const MC_input_currency = React.lazy(() => import("./Types/input_currency"))
const MC_date_flatpickr = React.lazy(() => import("./Types/date_flatpickr"))
const MC_input_text = React.lazy(() => import("./Types/input_text"))
const MC_input_date = React.lazy(() => import("./Types/input_date"))
const MC_react_chartjs_2 = React.lazy(() => import("./Types/react_chartjs_2"))
const MC_checkbox_inbox = React.lazy(() => import("./Types/checkbox_inbox"))
const MC_input_percentage = React.lazy(() => import("./Types/input_percentage"))
const MC_input_number = React.lazy(() => import("./Types/input_number"))
const MC_esc_date_flatpickr = React.lazy(
  () => import("./Types/esc_date_flatpickr")
)
const MC_check_yes_no = React.lazy(() => import("./Types/check_yes_no"))
const MC_year_picker = React.lazy(() => import("./Types/year_picker"))
const MC_array_input = React.lazy(() => import("./Types/array_input"))
const MC_check_custom_option = React.lazy(
  () => import("./Types/check_custom_option")
)
const MC_input_api = React.lazy(() => import("./Types/input_api"))
const MC_month_year_picker = React.lazy(
  () => import("./Types/month_year_picker")
)
const MC_input_textarea = React.lazy(() => import("./Types/input_textarea"))
const MC_checkbox = React.lazy(() => import("./Types/checkbox"))
const MC_input_checkbox = React.lazy(() => import("./Types/checkbox_custom"))
const MC_select2_icon_option = React.lazy(
  () => import("./Types/select2_icon_option")
)
const MC_input_time = React.lazy(() => import("./Types/input_time"))
const MC_select_day = React.lazy(() => import("./Types/select_day"))
const MC_select2 = React.lazy(() => import("./Types/select2"))
const MC_space = React.lazy(() => import("./Types/space"))
const MC_select2_select_all = React.lazy(
  () => import("./Types/select2_select_all")
)
const MC_select_range_date = React.lazy(
  () => import("./Types/select_range_date")
)
const MC_readonly_html = React.lazy(() => import("./Types/readonly_html"))
const MC_button_api = React.lazy(() => import("./Types/button_api"))
const MC_input_multi_lines = React.lazy(
  () => import("./Types/input_multi_lines")
)
const MC_search_task_relation = React.lazy(
  () => import("./Types/search_task_relation_2")
)
const MC_editor_html = React.lazy(() => import("./Types/editor_html"))
const MC_input_password_custom = React.lazy(
  () => import("./Types/input_password_custom")
)
const List = {
  check_with_icon: MC_check_with_icon,
  check_inbox: MC_check_inbox,
  select_year_month: MC_select_year_month,
  input_currency: MC_input_currency,
  date_flatpickr: MC_date_flatpickr,
  input_text: MC_input_text,
  input_date: MC_input_date,
  react_chartjs_2: MC_react_chartjs_2,
  checkbox_inbox: MC_checkbox_inbox,
  input_number: MC_input_number,
  input_percentage: MC_input_percentage,
  esc_date_flatpickr: MC_esc_date_flatpickr,
  check_yes_no: MC_check_yes_no,
  year_picker: MC_year_picker,
  array_input: MC_array_input,
  check_custom_option: MC_check_custom_option,
  input_api: MC_input_api,
  month_year_picker: MC_month_year_picker,
  input_textarea: MC_input_textarea,
  checkbox: MC_checkbox,
  checkbox_custom: MC_input_checkbox,
  select2_icon_option: MC_select2_icon_option,
  input_time: MC_input_time,
  select_day: MC_select_day,
  select2_custom: MC_select2,
  space: MC_space,
  select2_select_all: MC_select2_select_all,
  select_range_date: MC_select_range_date,
  readonly_html: MC_readonly_html,
  button_api: MC_button_api,
  input_multi_lines: MC_input_multi_lines,
  search_task_relation: MC_search_task_relation,
  editor_html: MC_editor_html,
  input_password_custom: MC_input_password_custom,
}
const MyControlOne = {
  init() {
    MyControlHelpers.addTypesFromListLazy(List)
  },
}

export default MyControlOne
